import React from 'react';
import Icon from "../../../Icon";
import linkIcon from "../../../../assets/icons/vimeo.svg";
import { Link, InLineContainer } from './styles';

interface VimeoLinkProps {
  url: string;
  children?: React.ReactNode;
  text?: string;
}

const VimeoLink: React.FC<VimeoLinkProps> = ({
  url,
  children,
  text = "Ver video en Vimeo"
}) => {
  return (
    <Link
      target="_blank"
      href={url}
    >
      <InLineContainer>
        {children || text}
        <Icon size={"15px"} icon={linkIcon} color="#121619" />
      </InLineContainer>
    </Link>
  );
};

export default VimeoLink;
